import { CircularProgress, Stack } from '@mui/material'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from './AuthProvider'
import { ChangePasswordPage } from '../pages/ChangePasswordPage'
import { WrongConsolePage } from '../pages/WrongConsolePage'
import { isLocalDevHost, isManagementConsole } from '../lib/console'

export function ProtectedRoute() {
  const auth = useAuth()
  const location = useLocation()
  if (auth.loading) return <Stack minHeight="100vh" alignItems="center" justifyContent="center"><CircularProgress /></Stack>
  if (!auth.authenticated) return <Navigate to="/login" replace state={{ from: location.pathname }} />
  // Entrou com senha temporária (recuperação de senha): obriga a definir uma nova antes
  // de qualquer tela. clearMustChangePassword() no sucesso libera o <Outlet/>.
  if (auth.mustChangePassword) return <ChangePasswordPage />

  // Barreira de console: SUPER_ADMIN abre os dois; admin de plataforma (não-super) só o de
  // gestão; cliente/agência só o do cliente. Em localhost nada é restringido (testa os dois
  // papéis na mesma máquina).
  if (!auth.isSuperAdmin && !isLocalDevHost()) {
    const staff = auth.isAdmin || auth.isAdminReadOnly
    if (isManagementConsole() && !staff) return <WrongConsolePage target="client" />
    if (!isManagementConsole() && staff) return <WrongConsolePage target="management" />
  }

  return <Outlet />
}
